module.exports = __webpack_public_path__ + "img/jorge-carlos-montoya-manrique.c30fdf4c.png";